// extracted by mini-css-extract-plugin
export var close_icon = "modal_section-module--close_icon--a3d2c";
export var non_scroll = "modal_section-module--non_scroll--d7792";
export var section_modal = "modal_section-module--section_modal--977a1";
export var youtube_image = "modal_section-module--youtube_image--7e435";
export var youtube_wrapper = "modal_section-module--youtube_wrapper--56236";